/**
 * @module FE-CU44_緊急連絡先設定画面_救急情報_削除ダイアログコンポーネント
 */
export default {
  name: 'DeleteConfirmModal',
  components: {},
  props: ['person', 'dialog', 'disabled'],
  data() {
    return {
      deleteDialog: this.dialog,
      continueDialog: false,
      childPerson: this.person,
    };
  },
  computed: {},
  /** @type {Methods} */
  methods: {
    /**
     * いいえボタン押下処理
     */
    closeModal() {
      this.deleteDialog = false;
    },
    /**
     * 削除処理
     */
    deleteConfirm() {
      this.$emit('delete-confirm', this.childPerson.id);
      this.closeModal();
    },
  },
};
